import React from 'react';
import { Anchor, Heading, Iframe, List, ListItem, Separator } from 'telia-front-react';
import { isCurrentDealerPath } from './util/MenuItemUtil';
import SsoModule from './util/SsoModule';
const headerEmployee = (rootStore) => {
    const { currentPath, setLocation } = rootStore.locationStore;
    const { translate } = rootStore.translationsStore;
    const { dealerMenuItems, dealerMenuActionItems } = rootStore.menuItemStore;
    const { tier, URLData, skipSsoModule } = rootStore.environmentStore;
    const { authData, showDealerSessionExpirationNotice, getSessionExpirationLoginUrl, getEmployeeSettingsUrl } = rootStore.ssoStore;
    const dealerMenuDropdownContentUrl = showDealerSessionExpirationNotice ? getSessionExpirationLoginUrl() : getEmployeeSettingsUrl();
    const employeeAddEvent = (event) => {
        if (document.getElementById('issue-registration-form')) {
            event.preventDefault();
            const type = 'issueFormOpened';
            let customEvent;
            if (typeof CustomEvent === 'function') {
                customEvent = new CustomEvent(type);
            }
            else {
                customEvent = document.createEvent('CustomEvent');
                customEvent.initCustomEvent(type, false, false, false);
            }
            window.dispatchEvent(customEvent);
        }
    };
    if (!authData.isDealer || !dealerMenuItems) {
        return null;
    }
    const createDropdownContent = (parentMenuItem) => {
        return (React.createElement(React.Fragment, null,
            React.createElement(Heading, { element: "h5" }, parentMenuItem.label),
            React.createElement(Separator, { color: "invisible", spacing: "small" }),
            React.createElement(List, { type: "unstyled" }, parentMenuItem.children.map((menuItem) => (React.createElement(ListItem, { key: menuItem.id },
                React.createElement(Anchor, { className: "header__megamenu-link", target: menuItem.target, isUnderlined: false, isTextColor: true, url: menuItem.url }, menuItem.label)))))));
    };
    const getActionItemsFromMenu = () => (dealerMenuActionItems || []).map((menuItem) => {
        var _a, _b;
        return ({
            id: `${menuItem.id}`,
            label: menuItem.label,
            dropdownContent: ((_a = menuItem.children) === null || _a === void 0 ? void 0 : _a.length) ? createDropdownContent(menuItem) : undefined,
            dropdownPadding: 'small',
            dropdownSize: 'small',
            showArrow: !!((_b = menuItem.children) === null || _b === void 0 ? void 0 : _b.length),
            icon: menuItem.icon ? `#${menuItem.icon}` : undefined,
            hideLabel: !menuItem.label,
            url: menuItem.url,
            target: menuItem.target
        });
    });
    const actionItems = [
        {
            url: URLData.getSelfServiceURL('/teenindus/syndmused'),
            onClick: employeeAddEvent,
            label: 'Lisan uue sündmuse',
            id: 'employeeAddEvent',
            icon: '#service-add',
            hideLabel: true
        },
        {
            id: 'employeeSmartAuth',
            label: translate('header.dealer.smartAuth'),
            icon: '#id',
            hideLabel: true,
            url: URLData.getSelfServiceLink('/teenindus/isiku-tuvastamine'),
            target: '_blank'
        },
        {
            showArrow: true,
            icon: '#support',
            url: '#',
            label: authData.dealerName,
            labelClassName: 'nls_protected',
            id: 'employeeSettings',
            dropdownContent: skipSsoModule ? (React.createElement(Iframe, { url: dealerMenuDropdownContentUrl, title: 'Telia' })) : (React.createElement(SsoModule, { url: dealerMenuDropdownContentUrl, rootStore: rootStore })),
            dropdownPadding: skipSsoModule ? 'none' : 'small',
            dropdownSize: showDealerSessionExpirationNotice ? 'medium' : 'small'
        }
    ];
    return {
        environment: tier,
        segment: {
            items: dealerMenuItems.map((item) => ({
                label: item.label,
                onClick: setLocation,
                current: isCurrentDealerPath(currentPath, item.path),
                icon: { modifiers: `#${item.icon}`, size: 'xs' },
                url: !item.path.startsWith('http') ? URLData.getSelfServiceLink(item.path) : item.path
            }))
        },
        actions: {
            items: getActionItemsFromMenu().concat(actionItems)
        }
    };
};
export default headerEmployee;
//# sourceMappingURL=HeaderEmployee.js.map